module.exports = __webpack_public_path__ + "static/media/fave-feed-modal-4.0a87c26c.svg";